import React, { useState, useEffect } from 'react';
import { useTable, Column } from 'react-table';

interface IProps {
    data: any;
}

interface AvailabilityRow {
    time: string;
    mon: boolean;
    tue: boolean;
    wed: boolean;
    thu: boolean;
    fri: boolean;
    sat: boolean;
    sun: boolean;
    rowIndex: number;
}


const Availability = ({ data }: IProps) => {
    const [cells, setCells] = useState<boolean[][]>(Array(24).fill(null).map(() => Array(7).fill(false)));

    const profile = data.instructor_profile;

    useEffect(() => {
        if (profile.availability && profile.availability.m) {
            const arr = [
                profile.availability.m,
                profile.availability.tu,
                profile.availability.w,
                profile.availability.th,
                profile.availability.f,
                profile.availability.sa,
                profile.availability.su,
            ];

            const transposedCells = Array(24).fill(null).map((_, rowIndex) =>
                arr.map(dayArr => dayArr[rowIndex] ?? false)
            );

            setCells(transposedCells);
        }
    }, [profile.availability]);

    const columns: Column<AvailabilityRow>[] = React.useMemo(
        () => [
            { Header: 'Time', accessor: 'time' },
            { Header: 'Mon', accessor: 'mon' },
            { Header: 'Tue', accessor: 'tue' },
            { Header: 'Wed', accessor: 'wed' },
            { Header: 'Thu', accessor: 'thu' },
            { Header: 'Fri', accessor: 'fri' },
            { Header: 'Sat', accessor: 'sat' },
            { Header: 'Sun', accessor: 'sun' },
        ],
        []
    );


    const dataTable = React.useMemo(
        () =>
            cells.map((row, index) => ({
                time: formaTime(index),
                mon: row[0],
                tue: row[1],
                wed: row[2],
                thu: row[3],
                fri: row[4],
                sat: row[5],
                sun: row[6],
                rowIndex: index,
            })),
        [cells]
    );

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
        columns,
        data: dataTable,
    });

    const toggleCell = (rowIndex: number, dayIndex: number) => {
        const updated = [...cells];
        updated[rowIndex][dayIndex] = !updated[rowIndex][dayIndex];
        setCells(updated);
    };

    return (
        <div className='card'>
            <div className='table-body mb-0'>
                <table {...getTableProps()} className='table table-sm table-bordered'>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map(row => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        if (cell.column.id === 'time') {
                                            return (
                                                <td {...cell.getCellProps()} className='pointer-disabled'>
                                                    {cell.render('Cell')}
                                                </td>
                                            );
                                        }

                                        return (
                                            <td
                                                {...cell.getCellProps()}
                                                style={{
                                                    backgroundColor: cell.value ? '#7cc7de' : '#fff',
                                                    cursor: 'pointer',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {cell.value ? '' : ''}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Availability;

const formaTime = (index: number) => {
    if (index === 12) return '12 PM';
    return index > 12
        ? (index - 12 < 10 ? '0' + (index - 12) : index - 12) + ' PM'
        : (index < 10 ? '0' + index : index) + ' AM';
};
